var io = require('socket.io-client');
var socket = io.connect(location.origin, {secure: true, transports: ['websocket']});

module.exports = socket;